import React, { useEffect } from 'react';
import {
  Autocomplete,
  TextField,
  InputAdornment,
  Box,
} from '@mui/material';
import { FilterList, Storefront, Straighten } from '@mui/icons-material';

interface BrowsingFiltersDropdownProps {
  title: string;
  options: string[];
  value?: string;
  setFilter: (selectedOption: string) => void;
}

const BrowsingFiltersDropdown: React.FC<BrowsingFiltersDropdownProps> = ({
  title,
  options,
  value,
  setFilter,
}) => {
  const [selected, setSelected] = React.useState<string | null>(null);

  // Pick an icon dynamically based on the filter title
  const getIcon = () => {
    switch (title.toLowerCase()) {
      case 'brand':
        return <Storefront color="action" />;
      case 'size':
        return <Straighten color="action" />;
      default:
        return <FilterList color="action" />;
    }
  };

  const handleChange = (_event: any, newValue: string | null) => {
    setSelected(newValue);
    setFilter(newValue || '');
  };

  // const handleClear = () => {
  //   setSelected(null);
  //   setFilter('');
  // };

  useEffect(() => {
    if (value == '') {
      setSelected(null);
    }
  }, [value])
  return (
    <Box display="flex" alignItems="center" width="100%" gap={1}>
      <Autocomplete
        fullWidth
        size="small"
        options={options}
        value={selected}
        onChange={handleChange}
        clearOnEscape
        renderInput={(params) => (
          <TextField
            {...params}
            label={title}
            InputProps={{
              ...params.InputProps,
              startAdornment: (
                <InputAdornment position="start">{getIcon()}</InputAdornment>
              ),
            }}
          />
        )}
      />

      {/* {selected && (
        <IconButton size="small" onClick={handleClear}>
          <CloseRounded fontSize="small" />
        </IconButton>
      )} */}
    </Box>
  );
};

export default BrowsingFiltersDropdown;
